import {
  FETCH_PROPOSALS_SUCCESS,
  FETCH_PROPOSAL_SUCCESS,
} from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_PROPOSALS_SUCCESS: {
      return { ...state, index: action.payload };
    }
    case FETCH_PROPOSAL_SUCCESS: {
      return { ...state, show: action.payload };
    }
    default:
      return state;
  }
};
